import React from "react";
import "./AboutIntro.css";
import { FiChevronDown } from "react-icons/fi";

function AboutIntro(props) {
  const [show, setShow] = React.useState("Who are we");
  const pillaArr = [
    {
      title: "Who are we",
      description:
        "ChildVision Academy based in Thembalethu, Mpumalanga, South Africa offers a three-year transformational leadership course for Orphan and Vulnerable Children Centre (OVC) workers who are empowered to transform the centres where they work.",
    },
    {
      title: "Impact",
      description:
        "Our 2021 students positively impact on more than 1 000 children.",
    },
    {
      title: "Target",
      description:
        "Our target is to change the lives of 10 000 children by 2025.",
    },
    {
      title: "Situation",
      description:
        "In South Africa there are many extremely poor communities who live without hope, and it is the children that suffer the most. In the midst of a hopeless situation, we are indebted to men and women in the community who have devoted their energies in establishing OVC Centres. These men and women need special help from us.",
    },
  ];

  const handleOpenPillar = (id) => {
    setShow(id);
  };

  const pillars = () => {
    return pillaArr.map((elem, i) => {
      return (
        <div key={elem.title}>
          {show === elem.title ? (
            <div
              id={elem.title}
              onClick={() => handleOpenPillar(elem.title)}
              className="aboutus "
              data-id={elem.title}
              style={{ backgroundColor: "rgba(34, 99, 34, 0.719)" }}
            >
              <p>{elem.title}</p>
              <FiChevronDown size={25} color="whitesmoke" />
            </div>
          ) : (
            <div
              id={elem.title}
              onClick={() => handleOpenPillar(elem.title)}
              className="aboutus"
              data-id={elem.title}
            >
              <p>{elem.title}</p>
              <FiChevronDown size={25} color="whitesmoke" />
            </div>
          )}
          {show === elem.title ? (
            <div id={elem.title} className="pillar__description">
              <p className="pillar__description-text">{elem.description}</p>
            </div>
          ) : null}
        </div>
      );
    });
  };

  return (
    <div className="AboutIntro">
      <div className="about__intro_container">
        <div
          id="about__intro_pillars"
          className="about__intro_pillars slow__hori__display"
        >
          {pillars()}
        </div>
      </div>
    </div>
  );
}

export default AboutIntro;
